import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { getReadableColorFromText } from '../helpers/color-from-text.util';

@Directive({
  selector: '[colorFromText]',
  standalone: true
})
export class ColorFromTextDirective implements OnInit, OnChanges {
  @Input('colorFromText') text: string | null | undefined;
  @Input() minContrast: number = 4.5; // WCAG AA para texto normal

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.applyColor();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['text']) {
      this.applyColor();
    }
  }

  private applyColor(): void {
    const base = (this.text || '').toString().trim();
    const color = getReadableColorFromText(base, this.minContrast);
    this.renderer.setStyle(this.el.nativeElement, 'color', color);
  }
}
